// const apiUrl = "https://api.compareairportparkingdeals.co.uk/api/v1"
// const apiUrl = "https://hangerapi.cloudshosting.co.uk/api/v1"
// const apiUrl = "http://localhost:8012/api/v1"/
const apiUrl = "https://hangernodeapi.cloudshosting.co.uk/api/v1"
// const apiUrl = "http://192.168.18.2:8012/api/v1"

// const apiUrl1 = "https://admin.compareairportparkingdeals.co.uk/api/v1.0"
const apiUrl1 = "https://cloudshosting.co.uk/api/v1.0"

export { apiUrl, apiUrl1 }
